import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'

const TournamentName = forwardRef(({ defaultTournamentName = '' }, ref) => {
  const [tournamentName, setTournamentName] = useState(defaultTournamentName)
  const [error, setError] = useState('')

  const val = () => {
    return tournamentName.trim()
  }

  const validate = () => {
    if (tournamentName.trim() === '') {
      setError('Название турнира обязательно')
      return false
    }
    setError('')
    return true
  }

  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))

  return (
    <TextField
      value={tournamentName}
      onChange={(e) => setTournamentName(e.target.value)}
      id="tournament_name"
      label="НАЗВАНИЕ ТУРНИРА"
      error={!!error}
      fullWidth
      // helperText={error}
    />
  )
})

export default TournamentName
